import i18nService from "../../services/i18n.service";

export async function i18nGuard(to, from, next) {
    const lang = to.query.lang;
    const defaultLanguage = i18nService.getDefaultLanguage();

    if (!lang) {
        return next({ path: to.path, query: { ...to.query, lang: defaultLanguage.code } });
    }

    const availableLanguages = await i18nService.getAvailableLanguages();

    const isAvailable = i18nService.isLanguageAvailable(lang, [...availableLanguages]); 
    if(!isAvailable){
        if(defaultLanguage.code !== lang){
            return next({ path: to.path, query: { ...to.query, lang: defaultLanguage.code } });
        }
        return next();
    }

    next();
}